import { jsxs as h, jsx as C } from "react/jsx-runtime";
const e = ({ size: t = 16, ...i }) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 35 24",
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ C("rect", { x: "0.5", y: "0.5", width: "34", height: "23", rx: "3.5", fill: "white", stroke: "#E5E7EB" }),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.545 19.3905C23.4425 19.4093 27 16.1827 27 12.2575C27 7.96549 23.4425 4.9984 19.545 5H16.1906C12.2467 4.9984 9 7.96629 9 12.2575C9 16.1835 12.2467 19.4093 16.1906 19.3905H19.545Z",
          fill: "#0079BE"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.2067 5.59473C12.6023 5.59593 9.68211 8.54379 9.68091 12.1822C9.68211 15.8201 12.6023 18.768 16.2067 18.7692C19.8114 18.768 22.7328 15.8201 22.7332 12.1822C22.7328 8.54379 19.8118 5.59593 16.2067 5.59473ZM12.0704 12.1822C12.0697 11.3409 12.3227 10.5191 12.7965 9.82392C13.2702 9.12879 13.9427 8.59275 14.7259 8.28586V16.0781C13.9426 15.7714 13.2701 15.2355 12.7963 14.5404C12.3225 13.8453 12.0695 13.0234 12.0704 12.1822ZM17.687 16.0797V8.28545C18.4708 8.59191 19.1439 9.12791 19.618 9.82327C20.0921 10.5186 20.3452 11.341 20.3441 12.1826C20.345 13.0241 20.0918 13.8464 19.6178 14.5417C19.1437 15.237 18.4707 15.7731 17.687 16.0797Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M19.545 19.3905C23.4425 19.4093 27 16.1827 27 12.2575C27 7.96549 23.4425 4.9984 19.545 5H16.1906C12.2467 4.9984 9 7.96629 9 12.2575C9 16.1835 12.2467 19.4093 16.1906 19.3905H19.545Z",
          fill: "#0079BE"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.2067 5.59473C12.6023 5.59593 9.68211 8.54379 9.68091 12.1822C9.68211 15.8201 12.6023 18.768 16.2067 18.7692C19.8114 18.768 22.7328 15.8201 22.7332 12.1822C22.7328 8.54379 19.8118 5.59593 16.2067 5.59473ZM12.0704 12.1822C12.0697 11.3409 12.3227 10.5191 12.7965 9.82392C13.2702 9.12879 13.9427 8.59275 14.7259 8.28586V16.0781C13.9426 15.7714 13.2701 15.2355 12.7963 14.5404C12.3225 13.8453 12.0695 13.0234 12.0704 12.1822ZM17.687 16.0797V8.28545C18.4708 8.59191 19.1439 9.12791 19.618 9.82327C20.0921 10.5186 20.3452 11.341 20.3441 12.1826C20.345 13.0241 20.0918 13.8464 19.6178 14.5417C19.1437 15.237 18.4707 15.7731 17.687 16.0797Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  e as DinersClubIcon
};
